import { createFileRoute } from '@tanstack/react-router';

import { AgentJobsScreen } from '../features/agent-jobs/AgentJobsScreen';

/**
 * `/agent-jobs` (§6.11). سطح مصغَّر (قرار D42): لا خانة تنقل مستقلة — الوصول من
 * «يحتاج انتباهك» وسجل النشاط. والمسار رقيق بحكم البنية: كل التركيب في
 * `features/agent-jobs`، ولا فلاتر في الـ URL لأن القائمة كلها قراءة واحدة.
 */
export const Route = createFileRoute('/agent-jobs')({ component: AgentJobsScreen });
